import gql from 'graphql-tag';

import { EventTrack } from 'src/app/helpers/analytics';
import { Video } from 'src/app/models/video';

export type AddToWatchlistFunction = (video: Video, pushEventTrack?: EventTrack) => VoidFunction;

export const GRAPHQL_ADD_WATCHLIST_MUTATION = gql`
  mutation addToWatchlist($videoId: ID!) {
    addVideoToWatchlist(videoId: $videoId) {
      isInWatchlist
    }
  }
`;

export const GRAPHQL_REMOVE_WATCHLIST_MUTATION = gql`
  mutation removeFromWatchlist($videoId: ID!) {
    removeVideoFromWatchlist(videoId: $videoId) {
      isInWatchlist
    }
  }
`;
